//© 2025 Kaitlyn Troxell
import React, { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from '../firebase';

function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showResetForm, setShowResetForm] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetSuccess, setResetSuccess] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError("Invalid email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setResetSuccess("");

    if (!resetEmail.trim()) {
      setError("Please enter your email address");
      setLoading(false);
      return;
    }

    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetSuccess("Password reset email sent! Check your inbox.");
      setResetEmail("");
      
      // Auto-switch back to login after 3 seconds
      setTimeout(() => {
        setShowResetForm(false);
        setResetSuccess("");
      }, 3000);
    } catch (err) {
      if (err.code === 'auth/user-not-found') {
        setError("No account found with this email address");
      } else if (err.code === 'auth/invalid-email') {
        setError("Invalid email address");
      } else {
        setError("Failed to send reset email. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (showResetForm) {
    return (
      <div className="login-container">
        <div className="login-form">
          <h2 className="login-title">
            Reset Password
          </h2>
          
          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          {resetSuccess && (
            <div style={{
              color: '#28a745',
              backgroundColor: '#d4edda',
              padding: '10px',
              borderRadius: '4px',
              marginBottom: '20px',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #c3e6cb'
            }}>
              {resetSuccess}
            </div>
          )}
          
          <form onSubmit={handlePasswordReset}>
            <div className="form-group">
              <label className="form-label">
                Email Address
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                required
                className="form-input"
              />
            </div>
            
            <button 
              type="submit" 
              disabled={loading}
              className={`login-submit ${loading ? 'loading' : ''}`}
            >
              {loading ? "Sending..." : "Send Reset Email"}
            </button>

            <button
              type="button"
              onClick={() => {
                setShowResetForm(false);
                setError("");
                setResetSuccess("");
              }}
              className="modal-cancel-btn"
              style={{ width: '100%', marginTop: '10px' }}
              disabled={loading}
            >
              Back to Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container" style={{
        backgroundImage: 'url(https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/river-valley.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#f0f9ff'
      }}>
      <div className="login-form">
        <h2 className="login-title">
          RVCG Calendar Login
        </h2>
        
        {error && (
          <div className="login-error">
            {error}
          </div>
        )}
        
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">
              Email Address
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-input"
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-input"
            />
          </div>
          
          <button 
            type="submit" 
            disabled={loading}
            className={`login-submit ${loading ? 'loading' : ''}`}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>

          <button
            type="button"
            onClick={() => setShowResetForm(true)}
            className="modal-cancel-btn"
            style={{ 
              width: '100%', 
              marginTop: '10px',
              backgroundColor: 'transparent',
              color: '#007bff',
              border: 'none',
              textDecoration: 'underline'
            }}
          >
            Forgot Password?
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;